module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9r7r4r-1d688c37ea30efb7ef523d64ee43b34e.svg";